module.exports = __webpack_public_path__ + "img/menu-icon-inquiry.af60f111.png";